import { FC, useEffect, useState } from "react";

interface SimpleLoaderProps {
  className?: string;
  words?: string[];
}

export const SimpleLoader: FC<SimpleLoaderProps> = ({
  className = "",
  words = ["Polishing", "Enhancing", "Beautifying"],
}) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayedChars, setDisplayedChars] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const fadeInTimer = setTimeout(() => {
      setIsVisible(true);
    }, 850);

    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
      setDisplayedChars(0);
    }, 3000);

    return () => {
      clearTimeout(fadeInTimer);
      clearInterval(interval);
    };
  }, [words.length]);

  const currentWord = words[currentWordIndex];

  useEffect(() => {
    setDisplayedChars(0);
    if (!currentWord) return;

    let i = 0;
    const typingInterval = setInterval(() => {
      i += 1;
      setDisplayedChars(i);
      if (i >= currentWord.length) clearInterval(typingInterval);
    }, 90);

    return () => clearInterval(typingInterval);
  }, [currentWordIndex, currentWord]);

  return (
    <div
      className={`flex flex-col items-center gap-3 transition-opacity duration-500 ease-in-out ${isVisible ? "opacity-100" : "opacity-0"} ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={40}
        height={40}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#2563eb"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="animate-spin text-muted-foreground"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span className="text-sm font-light text-muted-foreground">
        {currentWord.slice(0, displayedChars)}
        {displayedChars < currentWord.length && (
          <span className="animate-pulse">|</span>
        )}
      </span>
    </div>
  );
};
